// extracted by mini-css-extract-plugin
export default {"sizerContainer":"styles_sizerContainer__RQw82","sizeScroll":"styles_sizeScroll__W23BU","sizeInfo":"styles_sizeInfo__dNT1t","sizeInfoSmall":"styles_sizeInfoSmall__vX3Fh"};